import {bignumber, BigNumber} from "mathjs";
import {
  CommodityGroup,
  CommodityGroupCrudeOil,
  CommodityGroupLubricatingOil,
  CommodityGroupRefinedProducts,
  commodityGroups
} from "./commodity-group";
import {OutOfLimitsError} from "../error/out-of-limits-error";

export interface Commodity {
  group: CommodityGroup,
  k0Coefficient: BigNumber,
  k1Coefficient: BigNumber,
  k2Coefficient: BigNumber,
  dCoefficient: BigNumber
}

export const CommodityCrudeOil: Commodity = {
  group: commodityGroups.crudeOil,
  k0Coefficient: bignumber("341.0957"),
  k1Coefficient: bignumber("0"),
  k2Coefficient: bignumber("0"),
  dCoefficient: bignumber("2"),
}

export const CommodityFuelOils: Commodity = {
  group: commodityGroups.refinedProducts,
  k0Coefficient: bignumber("103.8720"),
  k1Coefficient: bignumber("0.2701"),
  k2Coefficient: bignumber("0"),
  dCoefficient: bignumber("1.3"),
}

export const CommodityJetFuels: Commodity = {
  group: commodityGroups.refinedProducts,
  k0Coefficient: bignumber("330.3010"),
  k1Coefficient: bignumber("0"),
  k2Coefficient: bignumber("0"),
  dCoefficient: bignumber("2"),
}

export const CommodityTransitionZone: Commodity = {
  group: commodityGroups.refinedProducts,
  k0Coefficient: bignumber("1489.0670"),
  k1Coefficient: bignumber("0"),
  k2Coefficient: bignumber("-0.00186840"),
  dCoefficient: bignumber("8.5"),
}

export const CommodityGasolines: Commodity = {
  group: commodityGroups.refinedProducts,
  k0Coefficient: bignumber("192.4571"),
  k1Coefficient: bignumber("0.2438"),
  k2Coefficient: bignumber("0"),
  dCoefficient: bignumber("1.5"),
}

export const CommodityLubricatingOil: Commodity = {
  group: commodityGroups.lubricatingOil,
  k0Coefficient: bignumber("0"),
  k1Coefficient: bignumber("0.34878"),
  k2Coefficient: bignumber("0"),
  dCoefficient: bignumber("1"),
}

export const getCommodity = (group: CommodityGroup, density: BigNumber): Commodity => {
  if (density.lessThan(group.kgm3At60Limits[0]) || density.greaterThan(group.kgm3At60Limits[1])) {
    throw new OutOfLimitsError(`The base density is outside the acceptable limits of the group ${group.name}`)
  }

  if (group === CommodityGroupCrudeOil) {
    return CommodityCrudeOil
  } else if (group === CommodityGroupLubricatingOil) {
    return CommodityLubricatingOil
  } else if (group === CommodityGroupRefinedProducts) {
    if (density.greaterThanOrEqualTo(bignumber("838.3127")) && density.lessThanOrEqualTo(bignumber("1163.5"))) {
      return CommodityFuelOils
    } else if (density.greaterThanOrEqualTo(bignumber("787.5195")) && density.lessThanOrEqualTo(bignumber("838.3127"))) {
      return CommodityJetFuels
    } else if (density.greaterThanOrEqualTo(bignumber("770.3520")) && density.lessThanOrEqualTo(bignumber("787.5195"))) {
      return CommodityTransitionZone
    } else {
      return CommodityGasolines
    }
  } else {
    throw new Error(`Unknown commodity group ${group.name}`)
  }
}
